import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, TABLE_STATUS_COLORS } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import useUserStore from "../stores/store";
import CustomLoader from "../component/menu/CustomLoader";
import { Tabs } from "antd";
import "../styles/TabsStyle.css";
import ApiService from "../utils/ApiService";
import { useNavigate } from "react-router-dom";
import TableStatusComponent from "../component/table/TableStatusComponent";
import LayoutFooterComponent from "../component/table/LayoutFooterComponent";
import BadgeComponent from "../component/table/BadgeComponent";
import LayoutHeaderComponent from "../component/table/LayoutHeaderComponent";
import useTableManagementStorage from "../stores/useTableManamentStore";
import { useLocation } from "react-router-dom";
import {
  getLayoutFloorsArrAsObj,
  replaceSelectedTablesInStore,
  updateFloorTabActiveKey,
  updateFloorTabActiveKeyOnInit,
} from "../utils/store-mutator.table-management";
import { getFormatedTabItems } from "../services/order-table-base-service";

function TableManagement() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, restaurantId, networkCall, setNetworkCall, showNotification } = useUserStore();
  const { layoutFloors, layoutSummary, setLayoutFloors, setLayoutSummary, floorTabActiveKey } =
    useTableManagementStorage();
  const [tabItems, setTabItems] = useState([]);

  async function getFloorAndTableLayout(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.GET_FLOOR_AND_TABLE_LAYOUT(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }

      const { payload } = res;
      if (payload.record) {
        if (payload?.record?.floors.length < 1) return;
        updateFloorTabActiveKeyOnInit(payload.record.floors);
        setLayoutFloors(getLayoutFloorsArrAsObj(payload.record.floors));
        setLayoutSummary(payload.record.statusSummary);
      }
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong!");
    } finally {
      setNetworkCall(false);
    }
  }

  async function getInitialRecords() {
    const params = {
      restaurantId,
    };
    await getFloorAndTableLayout(params);
  }

  const onClickTakeout = () => {
    navigate("/order/add?tablemanagement=Active&takeout=Yes&sourcePage=TABLE");
  };

  const onClickFloorTab = (tabKey) => {
    updateFloorTabActiveKey(tabKey);
  };
  /*Use effects*/
  useEffect(() => {
    setTabItems(getFormatedTabItems(restaurantId, Object.values(layoutFloors)));
  }, [layoutFloors]);

  useEffect(() => {
    getInitialRecords();
  }, []);

  useEffect(() => {
    if (!location.search) {
      replaceSelectedTablesInStore([], true);
    }
  }, [location.search]);
  /*Use effects*/

  return (
    <div className="flex flex-col font-uregular">
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.STAFF} currentMenuKey={"T_8_S_8"} />
      <CustomLoader />
      <div>
        <div className="flex flex-row bg-prewhite">
          <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.TABLE} />
          <div className="flex flex-col p-[24px] w-full mt-[80px] ml-[72px]">
            <div className="flex flex-col w-full">
              <div className="flex flex-col">
                <div className="flex flex-col bg-[#FAFAFA]">
                  <LayoutHeaderComponent />
                  <div className="flex flex-col bg-white p-[16px]">
                    <div className="flex flex-row justify-between items-center ">
                      <div className="flex flex-row gap-[24px] flex-start">
                        <TableStatusComponent
                          color={TABLE_STATUS_COLORS.AVAILABLE}
                          status="Available"
                          count={layoutSummary.available}
                        />
                        <TableStatusComponent
                          color={TABLE_STATUS_COLORS.ON_DINE}
                          status="On Dine"
                          count={layoutSummary.onDine}
                        />
                        <TableStatusComponent
                          color={TABLE_STATUS_COLORS.OCCUPIED}
                          status="Occupied"
                          count={layoutSummary.occupied}
                        />
                      </div>
                      <div className="flex flex-row gap-[24px] items-center">
                        <BadgeComponent
                          onClick={onClickTakeout}
                          color="#FFD700"
                          title="Takeout"
                          icon="/images/icons/take-away-svgrepo-com.svg"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    {!networkCall && tabItems.length === 0 ? (
                      <div className="w-full h-[70vh] flex items-center justify-center">
                        <div className="text-center">
                          <h1 className="text-2xl font-semibold leading-[44px] mb-5">
                            No tables found!
                            <br />
                            Please contact TableTap Authority to add floor plan.
                          </h1>
                        </div>
                      </div>
                    ) : (
                      <Tabs
                        defaultActiveKey="1"
                        activeKey={floorTabActiveKey}
                        onChange={(key) => onClickFloorTab(key)}
                        type="card"
                        size="middle"
                        style={{ marginBottom: 32 }}
                        items={tabItems}
                        className="h-vh custom-tabs blink-table"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer */}
        <LayoutFooterComponent />
      </div>
    </div>
  );
}

export default TableManagement;
